module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-profile-jodie.dd22c48.png";